var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _dec8, _dec9, _dec0, _class2, _descriptor8, _descriptor9, _descriptor0;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait from "../../Decorators/objectArrayTrait";
import objectTrait from "../../Decorators/objectTrait";
import primitiveArrayTrait from "../../Decorators/primitiveArrayTrait";
import primitiveTrait from "../../Decorators/primitiveTrait";
import mixTraits from "../../mixTraits";
import ScaleByDistanceTraits from "../ScaleByDistanceTraits";
import { BinStyleTraits, EnumStyleTraits, TableStyleMapSymbolTraits, TableStyleMapTraits } from "./StyleMapTraits";
export let PointSymbolTraits = (_dec = primitiveTrait({
  name: "Marker (icon)",
  description: 'Marker used to symbolize points. Default is "point"/"circle". This can be a URL, [data URI](https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs) or one of the supported [Maki icons](https://labs.mapbox.com/maki-icons/) (eg "hospital")',
  type: "string"
}), _dec2 = primitiveTrait({
  name: "Rotation",
  description: "Rotation of marker in degrees (clockwise).",
  type: "number"
}), _dec3 = primitiveArrayTrait({
  name: "Pixel offset",
  description: "Pixel offset in screen space from the origin. [x, y] format",
  type: "number"
}), _dec4 = primitiveTrait({
  name: "Height",
  description: "Height of the marker (in pixels).",
  type: "number"
}), _dec5 = primitiveTrait({
  name: "Width",
  description: "Width of the marker (in pixels).",
  type: "number"
}), _dec6 = objectTrait({
  name: "Scale by distance",
  description: "Scales a point, billboard or label feature by its distance from the camera.",
  type: ScaleByDistanceTraits,
  isNullable: true
}), _dec7 = primitiveTrait({
  name: "Disable depth test distance",
  description: "The distance from camera at which to disable depth testing, for example to prevent clipping of features againts terrain. Set to a very large value like 99999999 to disable depth testing altogether. When not defined or set to 0, depth testing is always applied.",
  type: "number"
}), _class = class PointSymbolTraits extends mixTraits(TableStyleMapSymbolTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "marker", _descriptor, this);
    _initializerDefineProperty(this, "rotation", _descriptor2, this);
    _initializerDefineProperty(this, "pixelOffset", _descriptor3, this);
    _initializerDefineProperty(this, "height", _descriptor4, this);
    _initializerDefineProperty(this, "width", _descriptor5, this);
    _initializerDefineProperty(this, "scaleByDistance", _descriptor6, this);
    _initializerDefineProperty(this, "disableDepthTestDistance", _descriptor7, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "marker", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "point";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "rotation", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "pixelOffset", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "height", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 16;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "width", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 16;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "scaleByDistance", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "disableDepthTestDistance", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export class EnumPointSymbolTraits extends mixTraits(PointSymbolTraits, EnumStyleTraits) {}
_defineProperty(EnumPointSymbolTraits, "isRemoval", EnumStyleTraits.isRemoval);
export class BinPointSymbolTraits extends mixTraits(PointSymbolTraits, BinStyleTraits) {}
_defineProperty(BinPointSymbolTraits, "isRemoval", BinStyleTraits.isRemoval);
let TablePointStyleTraits = (_dec8 = objectArrayTrait({
  name: "Enum point styles",
  description: "The point style to use for enumerated values.",
  type: EnumPointSymbolTraits,
  idProperty: "index"
}), _dec9 = objectArrayTrait({
  name: "Bin point styles",
  description: "The point style to use for bin values.",
  type: BinPointSymbolTraits,
  idProperty: "index"
}), _dec0 = objectTrait({
  name: "Enum Colors",
  description: "The default point style.",
  type: PointSymbolTraits
}), _class2 = class TablePointStyleTraits extends mixTraits(TableStyleMapTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "enum", _descriptor8, this);
    _initializerDefineProperty(this, "bin", _descriptor9, this);
    _initializerDefineProperty(this, "null", _descriptor0, this);
  }
}, _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "enum", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "bin", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "null", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new PointSymbolTraits();
  }
}), _class2);
export { TablePointStyleTraits as default };